import { AssigneeType } from 'api/clients/PropertyClient'
import { CopyModal } from 'components/CopyModal/CopyModal'
import ActionModal from 'components/NavRightClickMenu/components/ActionModal/ActionModal'
import { useArticle } from 'hooks/queries/articles/useArticle'
import { useFolder } from 'hooks/queries/folders/useFolder'
import { CopyFileActionConfigModalProps } from './Types'

const CopyFileActionConfigModal = (props: CopyFileActionConfigModalProps) => {
  const workflowFolderQuery = useFolder(props.workflowFolderKey)
  const articleQuery = useArticle(props.assignee.id || '', {
    enabled: Boolean(props.assignee.id) && props.assignee.type === AssigneeType.Article,
  })

  if (workflowFolderQuery.isLoading || articleQuery.isLoading) {
    return null
  }

  if (props.assignee.type === AssigneeType.Article) {
    const article = articleQuery.data?.article || {
      title: props.assignee.title || 'Untitled',
      header_emoji: null,
      linked_copies_count: 0,
    }

    return (
      <CopyModal
        item={article}
        closeModal={props.onClose}
        onItemCopied={() => {}}
        folder={workflowFolderQuery.data?.folder}
        onSubmit={(payload) => {
          props.onConfirm(payload)
          props.onClose()
        }}
      />
    )
  }

  if (props.assignee.type === AssigneeType.Project) {
    return (
      <ActionModal
        titleText="Pick a location"
        visible
        setVisible={(visible) => {
          if (!visible) {
            props.onCancel?.()
          }
        }}
        selectedFiles={[]}
        disableRoot
        submit={({ selectedFolder, newWorkspaceId }) => {
          props.onConfirm({ destination_folder_key: selectedFolder?.id, destination_workspace_id: newWorkspaceId })
          props.onClose()
        }}
        ctaText="Select Location"
        isMove={false}
        hidePopover
        skipConfirmation
        initialFolder={workflowFolderQuery.data?.folder}
      />
    )
  }

  return null
}

export { CopyFileActionConfigModal }
